import { parseInt } from 'lodash';

export function numberToString(n: number) {
  return new Intl.NumberFormat().format(n);
}

export function stringToNumber(str: string) {
  return parseInt(str.replace(/,/g, ''));
}
